<template>
  <label class="checkbox">
    <input type="checkbox" class="checkbox__input" @click="change" checked />
    <span class="checkbox__box"></span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: "CheckBox",
  props: ["value"],
  methods: {
    change() {
      if (!Array.isArray(this.value)) {
        this.$emit("input", !this.value);
      } else {
        let index = this.value.indexOf(this.$attrs.value);
        if (index >= 0) {
          this.$emit(
            "input",
            this.value.filter((item) => item != this.$attrs.value)
          );
        } else {
          let ret = this.value.map((e) => e);
          ret.push(this.$attrs.value);
          this.$emit("input", ret);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.checkbox {
  display: flex;
  white-space: nowrap;
  align-items: center;
  cursor: pointer;

  &__input {
    display: none;
    position: absolute;
    appearance: none;
    -webkit-appearance: none;

    &:focus + .checkbox__box {
      border: 1px solid red;
    }
  }

  &__input:checked + .checkbox__box::after {
    background-image: url("../images/utils/check.svg");
    background-size: contain;
    background-repeat: no-repeat;
    width: 16px;
    height: 16px;
    position: absolute;
    left: 3px;
    top: 2px;
    content: "";
    display: block;
  }

  &__box {
    display: none;
    position: absolute;
    width: 24px;
    height: 24px;
    border: 1px solid #828282;
    background-color: transparent;
  }
}
</style>
